import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from '../Badge';
type Post = {
  category: string;
  title: string;
  excerpt: string;
  date: string;
  readTime: string;
};
const posts: Post[] = [{
  category: 'Research',
  title: 'The 5-Minute Rule: Why Speed Determines 78% of Deals',
  excerpt: 'A deep dive into the Harvard study of 1.25M leads — and what it really means for service businesses fighting for the first response.',
  date: 'May 6, 2026',
  readTime: '7 min read'
}, {
  category: 'Case Study',
  title: 'How a $2M Plumbing Company 3×’d Their Booked Jobs in 30 Days',
  excerpt: 'Before: 23-minute average response time and a 6% close rate. After: 12 seconds and 19%. Here is exactly what changed.',
  date: 'Apr 22, 2026',
  readTime: '5 min read'
}, {
  category: 'Playbook',
  title: 'AI vs Human Reps: When Each One Wins (and When They Lose)',
  excerpt: 'A practical framework for deciding where AI belongs in your funnel — and the moments where a human still closes more.',
  date: 'Apr 9, 2026',
  readTime: '8 min read'
}];
function PostCard({
  post
}: {
  post: Post;
}) {
  return <a href="#" className="group flex flex-col border border-gray-300 rounded-2xl bg-white overflow-hidden hover:border-navy-500 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-navy-500 focus-visible:ring-offset-2" data-id="element-7">
      {/* Image placeholder */}
      <div className="aspect-[16/9] bg-gray-100 border-b border-gray-200 flex items-center justify-center" data-id="element-8">
        <span className="italic text-sm text-gray-400" data-id="element-9">image</span>
      </div>

      <div className="flex flex-col gap-3 p-5 sm:p-6 flex-1" data-id="element-10">
        <div className="flex items-center gap-2" data-id="element-11">
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full bg-navy-50 text-navy-500 border border-navy-500/15 uppercase tracking-[0.15em] text-[10px] font-semibold" data-id="element-12">
            {post.category}
          </span>
        </div>

        <h3 className="text-base sm:text-lg font-semibold text-gray-900 leading-snug group-hover:text-gray-700 transition-colors" data-id="element-13">
          {post.title}
        </h3>

        <p className="text-sm text-gray-600 leading-relaxed flex-1" data-id="element-14">
          {post.excerpt}
        </p>

        <div className="flex items-center gap-2 text-xs text-gray-500 pt-2 border-t border-gray-100" data-id="element-15">
          <span data-id="element-16">{post.date}</span>
          <span aria-hidden data-id="element-17">·</span>
          <span data-id="element-18">{post.readTime}</span>
          <span className="ml-auto text-gray-900 font-medium group-hover:translate-x-0.5 transition-transform" aria-hidden data-id="element-19">
            →
          </span>
        </div>
      </div>
    </a>;
}
export function Blog() {
  return <section id="blog" className="w-full border-b border-gray-200 bg-gray-50 px-4 sm:px-6 lg:px-12 py-12 sm:py-20 lg:py-24 scroll-mt-20" data-id="element-20">
      <div className="mx-auto max-w-[1280px]" data-id="element-21">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10 sm:mb-14" data-id="element-22">
          <div className="flex flex-col gap-3 max-w-2xl" data-id="element-23">
            <div className="text-[11px] uppercase tracking-[0.2em] text-gray-500 font-semibold" data-id="element-24">
              From the blog
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-900 tracking-tight leading-[1.1]" data-id="element-25">
              Speed is a science. We write about it.
            </h2>
          </div>
          <Link to="/blog" className="text-sm font-medium text-navy-500 underline underline-offset-4 hover:text-navy-800 self-start sm:self-end shrink-0" data-id="element-26">
            View all posts →
          </Link>
        </div>

        {/* Posts grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6" data-id="element-27">
          {posts.map(post => <PostCard key={post.title} post={post} data-id="element-28" />)}
        </div>
      </div>
    </section>;
}